import { useEffect } from "react";
import { NavigateFunction } from "react-router-dom";

import { AssignStatusFilter, PriorityFilterStatus } from "@/enum/list.enum";

import { IFilterWithValues } from "../../../List/components/FilterModal";

interface UseComposeUrlSyncArgs {
	selectedAssignStatus: AssignStatusFilter[];
	priorityFilterStatus: PriorityFilterStatus[];
	filter: IFilterWithValues | undefined;
	setSearchValue: (value: string) => void;
	navigate: NavigateFunction;
}

/**
 * Keeps Compose's assign-status / priority / filter selections mirrored into the URL query
 * string, and seeds the search box from it on mount.
 */
export function useComposeUrlSync({
	selectedAssignStatus,
	priorityFilterStatus,
	filter,
	setSearchValue,
	navigate,
}: UseComposeUrlSyncArgs) {
	useEffect(() => {
		const params = new URLSearchParams(location.search);

		setSearchValue(params.get("searchValue") || "");
	}, []);

	useEffect(() => {
		const params = new URLSearchParams(location.search);

		params.set("assignStatus", JSON.stringify(selectedAssignStatus));
		navigate({ search: params.toString() }, { replace: true });
	}, [selectedAssignStatus]);

	// Persist the Score filter to the URL (like assignStatus/filter) so it survives a page
	// refresh — e.g. the ALL set by a "Write message" add keeps the new unscored lead visible
	// after reload.
	useEffect(() => {
		const params = new URLSearchParams(location.search);

		params.set("priorityFilterStatus", JSON.stringify(priorityFilterStatus));
		navigate({ search: params.toString() }, { replace: true });
	}, [priorityFilterStatus]);

	useEffect(() => {
		// Update the URL when the filter changes
		const params = new URLSearchParams(location.search);

		if (filter) {
			params.set("filter", JSON.stringify(filter)); // Set filter parameter
		} else {
			params.delete("filter"); // Remove filter if empty
		}

		navigate({ search: params.toString() }, { replace: true });
	}, [filter, location.search, navigate]);
}
